var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5743_18800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.32 114.789V128.945H39.6792V114.789H29.6011V133.984C29.6011 136.773 31.8511 139.023 34.6401 139.023H115.359C118.148 139.023 120.398 136.773 120.398 133.984V114.789H110.32Z",
    fill: "url(#paint0_linear_5743_18800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.328 51.2578C126.328 38.2031 115.711 27.5859 102.656 27.5859C99.6328 27.5859 96.7266 28.1719 94.0781 29.2031C89.4609 18.4688 78.7734 10.9688 66.3516 10.9688C53.5781 10.9688 42.6797 18.8672 38.25 30.0234C36.3281 29.3906 34.2891 29.0859 32.1562 29.0859C21.0234 29.0859 12 38.0859 12 49.2188C12 50.8594 12.1875 52.5 12.6094 54.0234C5.10938 57.9844 0 65.8594 0 74.9531C0 88.0078 10.6172 98.6016 23.6953 98.6016H37.9453H108.211H126.328C139.406 98.6016 150 88.0078 150 74.9531C150 61.8516 139.406 51.2578 126.328 51.2578Z",
    fill: "#EFF0F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.539 90.0703C146.531 86.6016 147.68 82.5938 147.68 78.3047C147.68 65.2031 137.109 54.6328 124.031 54.6328C124.031 41.5781 113.414 30.9609 100.359 30.9609C97.3359 30.9609 94.4297 31.5469 91.8047 32.6016C87.1641 21.8672 76.4766 14.3672 64.0547 14.3672C54.5156 14.3672 46.0547 18.75 40.5234 25.6406C45.75 16.875 55.3594 11.0391 66.375 11.0391C78.7969 11.0391 89.4609 18.5156 94.1016 29.2734C96.75 28.2188 99.6562 27.6328 102.68 27.6328C115.734 27.6328 126.328 38.2266 126.328 51.2812C139.406 51.2812 150 61.875 150 75C150 80.7188 147.937 85.9922 144.539 90.0703Z",
    fill: "#DADBDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7031 88.7969L75 63.7891L95.2969 88.7969H85.4766V117.25H64.5234V88.7969H54.7031Z",
    fill: "url(#paint1_linear_5743_18800)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5743_18800",
    x1: 53.5714,
    y1: 102.307,
    x2: 96.3547,
    y2: 154.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0004B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5743_18800",
    x1: 65.4199,
    y1: 36.2547,
    x2: 109.909,
    y2: 47.1716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0004B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5743_18800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud_upload.adb2acfde1e5809280bc001f37963a1d.svg";
export { ForwardRef as ReactComponent };